import { Id } from '@/infra/id'
import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { unixEpoch } from '@/utils/date-util'

export interface ParticipantProps extends ModelProps<Participant> {}

/**
 * Represents a participant in a conversation.
 */
export class Participant extends Model<Participant> {
  @observable accessor userId = Id.none
  @observable accessor lastSeen = unixEpoch()
  @observable accessor muted = false
  @observable accessor dateCreated = unixEpoch()
  @observable accessor dateModified = unixEpoch()
}
